import { GroupReadjustmentQuoeficient } from '../enums/readjustmentQuoeficient.enum';
import { FinesAndInterests } from '../enums/FinesAndInterests.enum';
import { GroupDivision } from '../enums/GroupDivision';
import { CivilStatus } from '../enums/CivilStatus';
import { ContractType } from '../enums/ContractType';
import { ContactType } from '../enums/ContactType';
import { ContractClassification } from '../enums/ContractClassification';
import { PaymentType } from '../enums/PaymentType';
import { OwnerSegment } from '../enums/OwnerSegment';
import { HonorariumType } from '../enums/HonorariumType';
import { ContractStatus } from '../enums/ContractStatus';
import { TaxRegime } from '../enums/TaxRegime';
import { PositionType } from '../enums/PositionType';
import { BorrowNoteType } from '../enums/BorrowNote';
import { NoteType } from '../enums/NoteType';
import { PaymentTerm } from '../enums/PaymentTerm';
import { PaymentMethod } from '../enums/PaymentMethod';
import { PartnershipType } from '../enums/PartnershipType';
import { AllocationType } from '../enums/AllocationType';
import { LeaveType } from '../enums/LeaveType';
import * as ptLocale from 'date-fns/locale/pt';
import { DatepickerOptions } from 'ng2-datepicker';
import { DropDownList } from '../../models/DropDownList.model';
import { StatusApproval } from '../enums/StatusApproval';
import { StatusRefund } from '../enums/StatusRefund';
import { GroupOrigin } from '../enums/GroupOrigin';
import { SapItemType } from '../enums/SapItemType';
import { DropDownFactory } from '../../models/billing-letter/DropDown.factory';
import { LocalStorage } from "../wrappers/LocalStorage";
import { PixKeyType } from '../enums/PixKeyType';
import { StatusInvoice } from '../enums/StatusInvoice';
import { StatusJustification } from '../enums/StatusJustification';
import { GUARDS } from '../auth/Roles';
import { StatusKenoby } from '../enums/StatusKenoby';
import * as moment from 'moment';
import { ContractProjectFinancial } from '../enums/ContractProjectFinancial';
import { CertificateType } from '../enums/CertificateType';
import { AccountingType } from '../enums/AccountingBlockType';
import { SelfFillRequestStatus } from '../enums/SelfFillRequestStatus';
import { ProjectType } from '../enums/ProjectType';
import { PaymentMethodPurchaseOrder } from '../enums/PaymentMethodPurchaseOrder';
import { VendorInventoryType } from '../enums/VendorInventoryType';
import { PurchaseOrderType } from '../enums/PurchaseOrderType';
import { LaptopTransportType } from "../enums/LaptopTransportType";

export class CommonHelper {
    private localStorage: LocalStorage;

    getVerbs() {
        return [
            { _id: "GET", name: "Buscar" },
            { _id: "POST", name: "Criar" },
            { _id: "PUT", name: "Atualizar" },
            { _id: "DELETE", name: "Deletar" }
        ]
    }

    maskOnlyNumber(rawValue: string): RegExp[] {
        const mask = /[0-9]/;
        const validNumber = String(rawValue).length;
        const numberMask: RegExp[] = [];
        for (let i = 0; i <= validNumber; i++)
            numberMask.push(mask);
        return numberMask;
    }

    getConsultantVerboseFields() {
        return [
            { name: "name", verbose: "Nome" },
            { name: "email", verbose: "E-mail" },
            { name: "fcEmail", verbose: "E-mail Nação Digital" },
            { name: "cpf", verbose: "CPF" },
            { name: "begin", verbose: "Início de contrato" },
            { name: "rg", verbose: "RG" },
            { name: "bank", verbose: "Banco" },
            { name: "agency", verbose: "Agencia" },
            { name: "account", verbose: "Conta" },
            { name: "digit", verbose: "Dígito" },
            { name: "born", verbose: "Data de Nascimento" },
            { name: "responsible", verbose: "Responsável" },
            { name: "bp", verbose: "BP" },
            { name: "division", verbose: "Divisão" },
            { name: "subDivision", verbose: "Frente de negócio" },
            { name: "responsible", verbose: "Responsável" },
            { name: "contractKind", verbose: "Tipo de Contrato" },
            { name: "sex", verbose: "Sexo" },
            { name: "civilStatus", verbose: "Estado Civil" },
            { name: "motherName", verbose: "Nome da Mãe" },
            { name: "fatherName", verbose: "Nome do Pai" },
            { name: "homePhone", verbose: "Telefone" },
            { name: "cellPhone", verbose: "Celular" },
            { name: "cep", verbose: "CEP" },
            { name: "address", verbose: "Endereço" },
            { name: "number", verbose: "Número" },
            { name: "complement", verbose: "Complemento" },
            { name: "district", verbose: "Bairro" },
            { name: "city", verbose: "Cidade" },
            { name: "state", verbose: "Estado" },
            { name: "type", verbose: "Tipo" },
            { name: "name", verbose: "Nome" },
            { name: "phone", verbose: "Telefone" },
            { name: "kind", verbose: "Tipo de Contrato" },
            { name: "honorarium", verbose: "Honorário" },
            { name: "totalValue", verbose: "Valor Total" },
            { name: "paymentType", verbose: "Tipo de Pagamento" },
            { name: "mensalHours", verbose: "Horas Mensais" },
            { name: "soldHourValue", verbose: "Valor Hora Vendido" },
            { name: "hourValue", verbose: "Valor Hora" },
            { name: "benefits", verbose: "Benefícios" },
            { name: "position", verbose: "Cargo" },
            { name: "partnership", verbose: "Parceria" },
            { name: "allocation", verbose: "Alocação" },
            { name: "partnershipObs", verbose: "Observação" },
            { name: "contractStatus", verbose: "Status de contrato" },
            { name: "companyName", verbose: "Razão Social" },
            { name: "cnpj", verbose: "CNPJ" },
            { name: "taxRegime", verbose: "Regime Tributário" },
            { name: "cep", verbose: "CEP" },
            { name: "address", verbose: "Endereço" },
            { name: "number", verbose: "Número" },
            { name: "district", verbose: "Bairro" },
            { name: "city", verbose: "Cidade" },
            { name: "state", verbose: "Estado" },
            { name: "outsideSP", verbose: "Fora de SP" },
            { name: "cpom", verbose: "CPOM" },
            { name: "iss", verbose: "ISS" },
            { name: "irrf", verbose: "IRRF" },
            { name: "pcc", verbose: "PCC" },
            { name: "end", verbose: "Fim de Contrato" },
            { name: "consultantStart", verbose: "Início do Consultor" },
            { name: "consultantEnd", verbose: "Fim do Consultor" },
            { name: "customers", verbose: "Clientes" },
            { name: "keyPix", verbose: "Chave Pix" },
            { name: "excellenceCenter", verbose: "Centro de Excelência" },
            { name: "supportCenter", verbose: "Área de Suporte" },
        ]
    };

    cpfValidator(cpf) {
        let soma = 0, rest;
        if (cpf.indexOf('.') !== -1) {
            cpf = cpf.replace(/\./g, "");
            cpf = cpf.replace(/\-/g, "");
        }

        if (cpf.length != 11 ||
            cpf == "00000000000" ||
            cpf == "11111111111" ||
            cpf == "22222222222" ||
            cpf == "33333333333" ||
            cpf == "44444444444" ||
            cpf == "55555555555" ||
            cpf == "66666666666" ||
            cpf == "77777777777" ||
            cpf == "88888888888" ||
            cpf == "99999999999")
            return false;

        for (let i = 1; i <= 9; i++)
            soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        rest = (soma * 10) % 11;
        if ((rest == 10) || (rest == 11)) rest = 0;
        if (rest != parseInt(cpf.substring(9, 10))) return false;

        soma = 0;
        for (let i = 1; i <= 10; i++)
            soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
        rest = (soma * 10) % 11;
        if ((rest == 10) || (rest == 11)) rest = 0;
        if (rest != parseInt(cpf.substring(10, 11))) return false;

        return true;
    }

    phoneNumberValidator(phone){
        const brazilianCellPhoneRegex = /^\(\d{2}\)\d{5}-\d{4}$/gi;
        return brazilianCellPhoneRegex.test(phone);
    }

    transcriptSex(sex) {
        switch (sex) {
            case "0": return 'Não Informado'
            case "1": return 'Feminino'
            case "2": return 'Masculino'
        }
    }

    getCurrentUser() {
        return this.localStorage.retrieve("user");
    }

    getConfigurationMaskMoney() {
        return { prefix: 'R$ ', thousands: '.', decimal: ',' };
    }

    getDatePickerOptions(): DatepickerOptions {
        return {
            minYear: 1920,
            maxYear: 2030,
            displayFormat: 'DD/MM/YYYY',
            barTitleFormat: 'MMMM YYYY',
            firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
            locale: ptLocale,
            // minDate: new Date(Date.now()), // Minimal selectable date
            // maxDate: new Date(Date.now()),  // Maximal selectable date
            barTitleIfEmpty: 'Selecione uma data',
        };
    }

    getAllStatusApproval(): StatusApproval[] {
        return [StatusApproval.PendingApproval,
        StatusApproval.PendingPayment,
        StatusApproval.Paid,
        StatusApproval.AwaitingRational,
        StatusApproval.PendingRegularizationCompany]
    }

    getAllStatusRefund(): StatusRefund[] {
        return [StatusRefund.PendingApproval,
        StatusRefund.PartiallyApproved,
        StatusRefund.PendingPayment,
        StatusRefund.Paid,
        StatusRefund.Disapproved,
        StatusRefund.Canceled]
    }

    getAllPartnershipType(): PartnershipType[] {
        return [PartnershipType.Rational,
        PartnershipType.AccountingOutsourcing,
        PartnershipType.Others,
        PartnershipType.StayCalm]
    }

    getAllLeaveType(): LeaveType[] {
        return [LeaveType.CustomerRequest,
        LeaveType.AcceptedAnotherProposal,
        LeaveType.ConsultantRequestedDismissal,
        LeaveType.Internalization,
        LeaveType.ProjectClosure
        ]
    }

    getAllAllocationType(): AllocationType[] {
        return [AllocationType.Factory, AllocationType.Customer, AllocationType.FactorySantos, AllocationType.FullHome]
    }

    getAllTaxRegime(): TaxRegime[] {
        return [TaxRegime.NationalSimple, TaxRegime.PresumedProfit]
    }

    getAllBorrowNote(): BorrowNoteType[] {
        return [BorrowNoteType.Effective, BorrowNoteType.NoteBorrow]
    }

    getAllNoteType(): NoteType[] {
        return [NoteType.TaxNote, NoteType.DebitNote, NoteType.Invoice]
    }

    getAllPaymentTerm(): PaymentTerm[] {
        return [
            PaymentTerm._10d,
            PaymentTerm._15d,
            PaymentTerm._15d30d45d,
            PaymentTerm._20d,
            //PaymentTerm._20d30d,
            PaymentTerm._30d,
            PaymentTerm._30d60d90d,
            // PaymentTerm._40d,
            PaymentTerm._60d,
            PaymentTerm._90d,
            PaymentTerm._aVista30d60
        ]
    }

    getAllPaymentMethod(): PaymentMethod[] {
        return [
            PaymentMethod.ItauNacaoTed,
            PaymentMethod.ItauNacaoBoleto,
        ]
    }

    getAllPaymentMethodPurchaseOrder(): PaymentMethodPurchaseOrder[] {
        return [
            PaymentMethodPurchaseOrder.Boleto,
            PaymentMethodPurchaseOrder.Transferencia,
            PaymentMethodPurchaseOrder.CartaoCredito,
        ]
    }

    getAllPixTypes(): PixKeyType[]{
        return [
            PixKeyType.default,
            PixKeyType.phone,
            PixKeyType.email,
            PixKeyType.cpf_cnpj,
            PixKeyType.randomized
        ]
    }

    getAllPositionType(): PositionType[] {
        return [
            PositionType.TestAnalyst,
            PositionType.Developer,
            PositionType.ProjectManager,
            PositionType.WebDesign,
            PositionType.InfrastructureAnalyst,
            PositionType.SupportAnalyst,
            PositionType.ScrumMaster,
            PositionType.SeniorDBAAnalyst,
            PositionType.DBAJunior,
            PositionType.BDAdministrator,
            PositionType.NetworkAnalyst,
            PositionType.BusinessAnalyst,
            PositionType.TechnicalLeader,
            PositionType.BIAnalyst,
            PositionType.FraudManager,
            PositionType.RelationshipManager,
            PositionType.RequirementsAnalyst,
            PositionType.SystemsArchitect,
            PositionType.FunctionalAnalyst,
            PositionType.GovernmentAnalyst,
            PositionType.FullAlmAnalyst,
            PositionType.PRODUCTOWNER,
            PositionType.SystemAnalyst,
            PositionType.ProductionAnalyst,
            PositionType.SystemConfigurationManager,
            PositionType.InfrastructureLeader,
            PositionType.FullDataAnalyst,
            PositionType.UXExpert,
            PositionType.BDAnalyst,
            PositionType.QualityAnalyst,
            PositionType.InsideSales,
            PositionType.AzureConsultant,
            PositionType.Commercial,
            PositionType.AgileCoachSenior,
            PositionType.Head,
            PositionType.LeaderMarketing,
            PositionType.DevOps,
            PositionType.LeaderQA,
            PositionType.SecurityInformation,
            PositionType.DataScientist,
            PositionType.SEOAnalyst,
            PositionType.CybersecurityCoordinator,
            PositionType.SalesforceDeveloper,
            PositionType.AccountExecutive,
            PositionType.CopyWritingManager,
            PositionType.ChiefCommercialOffice,
            PositionType.HeadOfPerformance,
            PositionType.CustomerSuccess,
            PositionType.CrmAnalyst,
            PositionType.HeadOfProjectsAndEvolution,
            PositionType.MarketingIntern,
            PositionType.DesignIntern,
            PositionType.DesignExpert,
            PositionType.SeniorAccountExecutive,
            PositionType.MidContentAnalyst,
        ];
    }

    getAllBankName() {
        return [
            { 'name': 'Banco do Brasil', 'number': '001' },
            { 'name': 'Caixa Econômica Federal', 'number': '104' },
            { 'name': 'Citbank', 'number': '745' },
            { 'name': 'Banco Safra', 'number': '422' },
            { 'name': 'Santander', 'number': '033' },
            { 'name': 'Bradesco', 'number': '237' },
            { 'name': 'Itaú', 'number': '341' },
            { 'name': 'Neon', 'number': '735' },
            { 'name': 'Original', 'number': '212' },
            { 'name': 'Sicoob', 'number': '756' },
            { 'name': 'Banco Inter', 'number': '077' },
            { 'name': 'Banco Votorantim', 'number': '655' },
            { 'name': 'Nubank', 'number': '260' },
            { 'name': 'Agibank', 'number': '121' },
            { 'name': 'Cetelem', 'number': '739' },
            { 'name': 'Stone', 'number': '197' },
            { 'name': 'Sicredi', 'number': '748' },
            { 'name': 'Pagseguro', 'number': '290' },
            { 'name': 'Banco BS2', 'number': '218' },
            { 'name': 'Banco C6', 'number': '336' },
            { 'name': 'Banco do Nordeste', 'number': '004' },
            { 'name': 'CORA SCD', 'number': '403' },
            { 'name': 'Lift Bank', 'number': '280' },
            { 'name': 'Mercado Pago', 'number': '323' },
        ];
    }

    getAllContractStatus(): ContractStatus[] {
        return [ContractStatus.ConsultantSignature,
        ContractStatus.NacaoDigitalSignature,
        ContractStatus.Completed,
        ContractStatus.InElaboration,
        ContractStatus.Check];
    }

    getAllContractClassification(): ContractClassification[] {
        return [ContractClassification.Trainee,
        ContractClassification.Junior,
        ContractClassification.Pleno,
        ContractClassification.Senior];
    }

    getAllHonorariumType(): HonorariumType[] {
        return [HonorariumType.OpenHour,
        HonorariumType.ClosedHour];
    }

    getAllPaymentType(): PaymentType[] {
        return [PaymentType.OP,
        PaymentType.TED,
        PaymentType.ItauTransfer,
        PaymentType.BankDraft,
        PaymentType.PIX,];
    }

    getAllContactType(): ContactType[] {
        return [ContactType.Spouse,
        ContactType.Mother,
        ContactType.Others,
        ContactType.Father,
        ContactType.AuntOrUncle];
    }

    getAllContractProjectFinancial(): ContractProjectFinancial[] {
        return [
        ContractProjectFinancial.CustomerAnalysis,
        ContractProjectFinancial.JudiciaryAnalysis,
        ContractProjectFinancial.SignerContract,
        ];
    }

    getAllContractType(): ContractType[] {
        return [
            ContractType.CLT,
            ContractType.PJ,
            ContractType.Intern,
            ContractType.Others];
    }

    getAllCivilStatus(): CivilStatus[] {
        return [
            CivilStatus.Single,
            CivilStatus.Married,
            CivilStatus.Widower,
            CivilStatus.Divorced];
    }

    getAllInternalRoles() {
        return [
            //GUARDS.ADMIN,
            GUARDS.ADMINISTRATIVE,
            GUARDS.ADMINISTRATIVE_2,
            GUARDS.BILLSRECEIVE,
            GUARDS.BUSINESSPARTNER,
            GUARDS.COMMERCIAL,
            GUARDS.CONTROLLERSHIP,
            GUARDS.DP,
            GUARDS.FINANCES,
            GUARDS.GOVERNANCE,
            GUARDS.INFRA,
            GUARDS.JUDICIARY,
            GUARDS.MANAGER,
            GUARDS.RS
        ];
    }

    getAllOwnerSegmnet(division): OwnerSegment[] {
        switch (division) {
            case 1:
                return [
                    OwnerSegment.EXPONENTIAL_NICOLE,
                    OwnerSegment.EXPONENTIAL_LYSSA,
                ]
            case 3:
                return [
                    OwnerSegment.OMNI_FINANCE,
                    OwnerSegment.OMNI_PISANE,
                    OwnerSegment.OMNI_LOHAIN,
                    OwnerSegment.OMNI_MAZZINI,
                ]
            case 5:
                return [
                    OwnerSegment.FCNUVEM_LOUSADA,
                    OwnerSegment.FCNUVEM_TIAGO,
                ]
            default:
                return []
        }
    }

    transcriptOwnerSegmnet(ownerSegment: OwnerSegment) {
        switch (ownerSegment) {
            case OwnerSegment.FCNUVEM_LOUSADA:
                return "Leandro Lousada";
            case OwnerSegment.FCNUVEM_TIAGO:
                return "Tiago";
            case OwnerSegment.OMNI_FINANCE:
                return "Finance";
            case OwnerSegment.OMNI_PISANE:
                return "Gustavo Pisane";
            case OwnerSegment.OMNI_LOHAIN:
                return "Lohain";
            case OwnerSegment.OMNI_MAZZINI:
                return "Marcelo Mazzini";
            case OwnerSegment.EXPONENTIAL_NICOLE:
                return "Nicole"
            case OwnerSegment.EXPONENTIAL_LYSSA:
                return "Lyssa"
        }
    }

    transcriptStatusApproval(statusApproval: StatusApproval) {
        switch (statusApproval) {
            case StatusApproval.PendingApproval:
                return "Aprovação Pendente";
            case StatusApproval.PendingPayment:
                return "Pagamento Pendente";
            case StatusApproval.Paid:
                return "Pago";
            case StatusApproval.AwaitingRational:
                return "Aguardando Racional";
            case StatusApproval.PendingRegularizationCompany:
                return "Pendente Regularização de Empresa";
            default:
                return "";
        }
    }

    transcriptStatusRefund(statusRefund: StatusRefund) {
        switch (statusRefund) {
            case StatusRefund.PendingApproval:
                return "Aprovação Pendente";
            case StatusRefund.PendingPayment:
                return "Pagamento Pendente";
            case StatusRefund.Paid:
                return "Pago";
            case StatusRefund.Disapproved:
                return "Reprovado";
            case StatusRefund.Canceled:
                return "Cancelado";
            case StatusRefund.PartiallyApproved:
                return "Aprovado Parcialmente";
            default:
                return "";
        }
    }

    transcriptBillingStatus(status?) {
        let list = [
            "Em aberto",
            "Liberado Nação Digital",
            "Liberado Cliente",
            "Aguardando Pagamento",
            "Pago",
            "Cancelado",
            "Perda contábil",
            "Perda competência"
        ];
        return list[status] ? list[status] : "-";
    }

    transcriptTaxRegime(taxRegime: TaxRegime) {
        switch (taxRegime) {
            case TaxRegime.NationalSimple:
                return "Simples Nacional";
            case TaxRegime.PresumedProfit:
                return "Lucro Presumido";
            default:
                return "";
        }
    }

    transcriptStatusKenoby(statusKenoby: StatusKenoby) {
        switch (statusKenoby) {
            case StatusKenoby.Pending:
                return "Pendente";
            case StatusKenoby.integrated:
                    return "Integrado";
            case StatusKenoby.declined:
                    return "Declinou";
            default:
                return "";
        }
    }

    transcriptProjectType(type: ProjectType) {
        switch (type) {
            case ProjectType.ProjectionCost:
                return "Projeção";
            case ProjectType.Rational:
                    return "Racional";
            default:
                return "";
        }
    }

    transcriptPurchaseOrderType(type: PurchaseOrderType) {
        switch (type) {
            case PurchaseOrderType.PurchaseOrder:
                return "Pedidos de Compras";
            case PurchaseOrderType.PurchaseOrderUmbrella:
                    return "Pedidos Guarda Chuva";
            default:
                return "";
        }
    }

    transcriptCertificateType(certificateType: CertificateType) {
        switch (certificateType) {
            case CertificateType.Certificate:
                return "Certidão";
            case CertificateType.Procuration:
                return "Procuração";
            case CertificateType.Others:
                return "Outros";
            default:
                return "";
        }
    }

    transcriptPositionType(positionType: PositionType) {
        switch (positionType) {
            case PositionType.TestAnalyst:
                return "Analista de teste";
            case PositionType.Developer:
                return "Desenvolvedor";
            case PositionType.ProjectManager:
                return "Gerente de Projeto/PO";
            case PositionType.WebDesign:
                return "Web Design";
            case PositionType.InfrastructureAnalyst:
                return "Analista de Infraestrutura";
            case PositionType.SupportAnalyst:
                return "Analista de Suporte";
            case PositionType.ScrumMaster:
                return "Scrum Master";
            case PositionType.SeniorDBAAnalyst:
                return "Analista DBA Sênior";
            case PositionType.DBAJunior:
                return "DBA Júnior";
            case PositionType.BDAdministrator:
                return "Administrador de banco de dados (DBA)";
            case PositionType.NetworkAnalyst:
                return "Analista de Rede";
            case PositionType.BusinessAnalyst:
                return "Analista de Negócio";
            case PositionType.TechnicalLeader:
                return "Líder Técnico/Tech Leader";
            case PositionType.BIAnalyst:
                return "Analista BI";
            case PositionType.FraudManager:
                return "Gestor de Fraude";
            case PositionType.RelationshipManager:
                return "Gerente de Relacionamento";
            case PositionType.RequirementsAnalyst:
                return "Analista de Requisitos";
            case PositionType.SystemsArchitect:
                return "Arquiteto de Sistemas";
            case PositionType.FunctionalAnalyst:
                return "Analista Funcional";
            case PositionType.GovernmentAnalyst:
                return "Analista de Governança";
            case PositionType.FullAlmAnalyst:
                return "Analista Alm Pleno";
            case PositionType.PRODUCTOWNER:
                return "PRODUCT OWNER";
            case PositionType.SystemAnalyst:
                return "Analista de Sistema";
            case PositionType.ProductionAnalyst:
                return "Analista de Produção";
            case PositionType.SystemConfigurationManager:
                return "System Configuration Manager";
            case PositionType.InfrastructureLeader:
                return "Líder de Infraestrutura";
            case PositionType.FullDataAnalyst:
                return "Analista de Dados Pleno";
            case PositionType.UXExpert:
                return "Especialista UX";
            case PositionType.BDAnalyst:
                return "Analista de Bancos de Dados";
            case PositionType.QualityAnalyst:
                return "Analista de Qualidade";
            case PositionType.InsideSales:
                return "Inside Sales";
            case PositionType.AzureConsultant:
                return "Consultor Azure";
            case PositionType.Commercial:
                return "Comercial";
            case PositionType.AgileCoachSenior:
                return "Agile Coach Senior";
            case PositionType.Head:
                return "Head";
            case PositionType.LeaderMarketing:
                return "Líder de Marketing";
            case PositionType.DevOps:
                return "DevOps";
            case PositionType.LeaderQA:
                return "Líder de QA";
            case PositionType.SecurityInformation:
                return "Segurança da Informação";
            case PositionType.DataScientist:
                return "Cientista de Dados";
            case PositionType.SEOAnalyst:
                return "Analista de SEO";
            case PositionType.CybersecurityCoordinator:
                return "Coordenador De Cybersecurity";
            case PositionType.SalesforceDeveloper:
                return "Salesforce Developer";
            case PositionType.InnovationSpecialist:
                return "Especialista de Inovação";
            case PositionType.AccountExecutive:
                return "Account Executive";
            case PositionType.CopyWritingManager:
                return "Gerente de Brand Content e Copywriting";
            case PositionType.ChiefCommercialOffice:
                return "Diretora Comercial";
            case PositionType.HeadOfPerformance:
                return "Head of Performance";
            case PositionType.CustomerSuccess:
                return "Customer Success";
            case PositionType.CrmAnalyst:
                return "Analista de CRM";
            case PositionType.HeadOfProjectsAndEvolution:
                return "Head de Projetos e Evolução";
            case PositionType.MarketingIntern:
                return "Estágio de Marketing";
            case PositionType.DesignIntern:
                return "Estágio de Design";
            case PositionType.DesignExpert:
                return "Expert em Design";
            case PositionType.SeniorAccountExecutive:
                return "Executivo de Contas Sênior";
            case PositionType.MidContentAnalyst:
                return "Analista de Conteúdo Pleno";
            default:
                return "";
        }
    }

    transcriptBorrowNote(borrowNote: BorrowNoteType) {
        switch (borrowNote) {
            case BorrowNoteType.Effective:
                return "Efetivo";
            case BorrowNoteType.NoteBorrow:
                return "Nota Emprestada";
            default:
                return "";
        }
    }

    transcriptNoteType(noteType: NoteType) {
        switch (Number(noteType)) {
            case NoteType.TaxNote:
                return "Nota Fiscal";
            case NoteType.DebitNote:
                return "Nota de Débito";
            case NoteType.Invoice:
                return "Invoice";
            default:
                return "";
        }
    }

    transcriptPaymentTerm(paymentTerm: PaymentTerm) {
        switch (paymentTerm) {
            case PaymentTerm._10d:
                return "10 dias";
            case PaymentTerm._15d:
                return "15 dias";
            case PaymentTerm._15d30d45d:
                return "15, 30, 45 dias";
            case PaymentTerm._20d:
                return "20 dias";
            // case PaymentTerm._20d30d:
            //     return "20, 30 dias";
            case PaymentTerm._30d:
                return "30 dias";
            // case PaymentTerm._40d:
            //     return "40 dias";
            case PaymentTerm._30d60d90d:
                return "30, 60, 90 dias";
            case PaymentTerm._60d:
                return "60 dias";
            case PaymentTerm._90d:
                return "90 dias";
            case PaymentTerm._aVista30d60:
                return "À vista, 30 e 60 dias";
            default:
                return "";
        }
    }

    transcriptPaymentMethod(paymentMethod: PaymentMethod) {
        switch (paymentMethod) {
            case PaymentMethod.ItauNacaoTed:
                return "Itaú CC 99317-3 - TED"
            case PaymentMethod.ItauNacaoBoleto:
                return "Itaú CC 99317-3 - Boleto"
            default:
                return "";
        }
    }

    transcriptPaymentMethodPurchaseOrder(paymentMethodPurchaseOrder: PaymentMethodPurchaseOrder) {
        switch (paymentMethodPurchaseOrder) {
            case PaymentMethodPurchaseOrder.Boleto:
                return "Boleto";
            case PaymentMethodPurchaseOrder.Transferencia:
                return "Transferência";
            case PaymentMethodPurchaseOrder.CartaoCredito:
                return "Cartão de Crédito";
            default:
                return "";
        }
    }

    transcriptPixType(pixKeyType: PixKeyType){
        switch (pixKeyType) {
            case PixKeyType.default:
                return "Selecione uma chave"
            case PixKeyType.phone:
                return "Telefone"
            case PixKeyType.email:
                return "Email"
            case PixKeyType.cpf_cnpj:
                return "CPF/CNPJ"
            case PixKeyType.randomized:
                return "Aleatória"
            default:
                return "";
        }
    }

    transcriptPartnershipType(partnershipType: PartnershipType) {
        switch (partnershipType) {
            case PartnershipType.Rational:
                return "Rational";
            case PartnershipType.AccountingOutsourcing:
                return "Terceirização Contábil";
            case PartnershipType.Others:
                return "Outros";
            case PartnershipType.StayCalm:
                return "Fique Tranquilo";
            default:
                return "";
        }
    }

    transcriptAllocationType(allocationType: AllocationType) {
        switch (allocationType) {
            case AllocationType.Factory:
                return "Fábrica";
            case AllocationType.Customer:
                return "Cliente";
            case AllocationType.FactorySantos:
                return "Fábrica Santos";
            case AllocationType.FullHome:
                return "Full Home";
            default:
                return "";
        }
    }


    transcriptContractStatus(contractStatus: ContractStatus) {
        switch (contractStatus) {
            case ContractStatus.ConsultantSignature:
                return "Assinatura Consultor";
            case ContractStatus.NacaoDigitalSignature:
                return "Assinatura Nação Digital";
            case ContractStatus.Completed:
                return "Concluído";
            case ContractStatus.InElaboration:
                return "Em Elaboração";
            case ContractStatus.Check:
                return "Verificar";
            default:
                return "";
        }
    }

    transcriptContractClassification(contractClassification: ContractClassification) {
        switch (contractClassification) {
            case ContractClassification.Trainee:
                return "Trainee";
            case ContractClassification.Junior:
                return "Júnior";
            case ContractClassification.Pleno:
                return "Pleno";
            case ContractClassification.Senior:
                return "Sênior";
            default:
                return "";
        }
    }

    transcriptTerminantionType(contractTerminationType){
        switch (contractTerminationType) {
            case 1:
                return "Quitação";
            case 2:
                return "Distrato comum acordo";
            case 3:
                return "Distrato pela contratada";
            default:
                return "-";
        }
    }

    transcriptOutputDocumentGenerated(terminationType, generationDate) {
        generationDate = moment(generationDate, moment.ISO_8601).format('DD/MM/YYYY')
        return `${terminationType} gerado em ${generationDate}`
    }

    transcriptAdditiveType(additiveType: Number) {
        switch (additiveType) {
            case 1:
                return "Reajuste de valor";
            case 2:
                return "Renovação de contrato";
            case 3:
                return "Alteração de razão social ou CNPJ";
            default:
                return "";
        }
    }

    transcriptHonorariumType(honorariumType: HonorariumType) {
        switch (honorariumType) {
            case HonorariumType.OpenHour:
                return "Hora Aberta";
            case HonorariumType.ClosedHour:
                return "Hora Fechada";
            default:
                return "";
        }
    }

    transcriptVerb(verb) {
        switch (verb) {
            case "GET":
                return "Buscar";
            case "POST":
                return "Criar";
            case "PUT":
                return "Atualizar";
            case "DELETE":
                return "Deletar";
            default:
                return "";
        }
    }

    transcriptPaymentType(paymentType: PaymentType) {
        switch (paymentType) {
            case PaymentType.OP:
                return "OP";
            case PaymentType.TED:
                return "TED";
            case PaymentType.ItauTransfer:
                return "Transferência Itaú";
            case PaymentType.BankDraft:
                return "Cheque";
            case PaymentType.PIX:
                return "PIX";
            default:
                return "";
        }
    }

    transcriptLeaveType(leaveType: LeaveType) {
        switch (leaveType) {
            case LeaveType.CustomerRequest:
                return 'Solicitação do cliente';
            case LeaveType.AcceptedAnotherProposal:
                return 'Aceitou outra oportunidade';
            case LeaveType.ConsultantRequestedDismissal:
                return 'Consultor solicitou desligamento';
            case LeaveType.Internalization:
                return 'Internalização';
            case LeaveType.ProjectClosure:
                return 'Encerramento de projeto';
            case LeaveType.EndOfContract:
                return 'Fim de Contrato';
            case LeaveType.Others:
                return 'Outros';
            case LeaveType.IncompatibleProfile:
                return 'Perfil incompatibilizado';
            case LeaveType.Ethics:
                return 'Postura (Comportamento, ética, similares)';
            case LeaveType.Restructuring:
                return 'Restruturação';
            case LeaveType.UnsatisfiedWithClientOrProject:
                return 'Insatisfeito com o Cliente/Projeto';
            case LeaveType.InternationalOpportunity:
                return 'Oportunidade Internacional';
            case LeaveType.NationalPropositionChallenge:
                return 'Proposta Nacional (Desafio)';
            case LeaveType.PoorPerformance:
                return 'Baixa Performance';
            default:
                return "";
        }
    }

    transcriptContactType(contactType: ContactType) {
        switch (contactType) {
            case ContactType.Others:
                return "Outros";
            case ContactType.Father:
                return "Pai";
            case ContactType.Mother:
                return "Mãe";
            case ContactType.Spouse:
                return "Cônjuge";
            case ContactType.AuntOrUncle:
                return "Tia(o)";
            default:
                return "";
        }
    }

    transcriptContractProjectFinancial(contractProjetFinancial: ContractProjectFinancial) {
        switch (contractProjetFinancial) {
            case ContractProjectFinancial.CustomerAnalysis:
                return "Em Análise do Cliente";
            case ContractProjectFinancial.JudiciaryAnalysis:
                return "Análise do Jurídico";
            case ContractProjectFinancial.SignerContract:
                return "Contrato Assinado";
            default:
                return "";
        }
    }

    transcriptContractType(contractType: ContractType) {
        switch (contractType) {
            case ContractType.PJ:
                return "PJ";
            case ContractType.CLT:
                return "CLT";
            case ContractType.Intern:
                return "Estagiário";
            case ContractType.Others:
                return "Outros";
            default:
                return "";
        }
    }

    transcriptInternalRole(role: any) {
        switch (role) {
            case GUARDS.ADMINISTRATIVE:
                return "Administrativo";
            case GUARDS.ADMIN:
                return "Admin";
            case GUARDS.ADMINISTRATIVE_2:
                return "Administrativo 2";
            case GUARDS.BILLSRECEIVE:
                return "Contas a receber";
            case GUARDS.BUSINESSPARTNER:
                return "Business Partner";
            case GUARDS.COMMERCIAL:
                return "Comercial";
            case GUARDS.CONTROLLERSHIP:
                return "Controladoria";
            case GUARDS.DP:
                return "DP";
            case GUARDS.FINANCES:
                return "Contas a pagar";
            case GUARDS.GOVERNANCE:
                return "Governança";
            case GUARDS.INFRA:
                return "Infra";
            case GUARDS.JUDICIARY:
                return "Jurídico";
            case GUARDS.MANAGER:
                return "Gestor";
            case GUARDS.RS:
                return "RS";
            case GUARDS.TECHMANAGEMENT:
                return "Gestor Técnico";
            default:
                return "Sistema";
        }
    }

    transcriptActive(active) {
        switch (active) {
            case true:
                return "Ativo";
            case false:
                return "Inativo";
            case undefined:
                return "Inativo";
            default:
                return "";
        }
    }

    transcriptDivisionGroup(groupDivision: GroupDivision) {
        switch (groupDivision) {
            case GroupDivision.NacaoDigital:
                return "Nação Digital";
            default:
                return '-';
        }
    }

    transcriptOriginGroup(groupOrigin: GroupOrigin) {
        switch (groupOrigin) {
            case GroupOrigin.Marketing:
                return "Marketing";
            case GroupOrigin.Sales:
                return "Vendas";
            case GroupOrigin.Partner:
                return "Parceiro";
            case GroupOrigin.Indication:
                return "Indicação";
            default:
                return groupOrigin;
        }
    }

    transcriptReadjustmentQuoeficientGroup(groupReadjustmentQuoeficient: GroupReadjustmentQuoeficient) {
        switch (groupReadjustmentQuoeficient) {

            case GroupReadjustmentQuoeficient.IgpDiFgv:
                return "IGP-DI (FGV)";
            case GroupReadjustmentQuoeficient.IgpMFgv:
                return "IGP-M (FGV)";
            case GroupReadjustmentQuoeficient.Inpc:
                return "IPC (Fipe)";
            case GroupReadjustmentQuoeficient.Ipc:
                return "INPC (IBGE)";
            case GroupReadjustmentQuoeficient.Ipca:
                return "IPCA (IBGE)";
            case GroupReadjustmentQuoeficient.Aditivo:
                return "Aditivo";
            case GroupReadjustmentQuoeficient.NotApplicable:
                return "NÃO APLICÁVEL";
            default:
                return groupReadjustmentQuoeficient;
        }
    }

    getAllFinesAndInterests(): FinesAndInterests[] {
        return[
            FinesAndInterests.Fees,
            FinesAndInterests.Fine,
            FinesAndInterests.FinesAndInterest,
            FinesAndInterests.None,
        ];
    }

    transcriptFinesAndInterests(finesAndInterests: FinesAndInterests) {
        switch (finesAndInterests) {

            case FinesAndInterests.Fees:
                return "Possui Juros";
            case FinesAndInterests.Fine:
                return "Possui Multa";
            case FinesAndInterests.FinesAndInterest:
                return "Possui Juros e Multa";
            case FinesAndInterests.None:
                return "Não possui Juros e Multa";
            default:
                return FinesAndInterests;
        }
    }

    transcriptCivilStatus(civilStatus: CivilStatus) {
        switch (civilStatus) {
            case CivilStatus.Single:
                return "Solteiro(a)";
            case CivilStatus.Married:
                return "Casado(a)";
            case CivilStatus.Divorced:
                return "Divorciado(a)";
            case CivilStatus.Widower:
                return "Viúvo(a)";
            default:
                return "";
        }
    }

    transcriptSapItemType(sapItemType: SapItemType) {
        switch (sapItemType) {
            case SapItemType.CnaeBilling:
                return "CNAE de carta de faturamento";
            case SapItemType.CnaeConsultant:
                return "CNAE de consultor";
            case SapItemType.ItemPurchaseOrder:
                return "Item de pedido de compra";
            default:
                return "";
        }
    }

    getAllStatusKenoby(): StatusKenoby[] {
        return [
            StatusKenoby.Pending,
            StatusKenoby.integrated,
            StatusKenoby.declined
        ];
    }

    getAllProjectType(): ProjectType[] {
        return [
            ProjectType.ProjectionCost,
            ProjectType.Rational
        ];
    }

    getAllPurchaseOrderType(): PurchaseOrderType[] {
        return [
            PurchaseOrderType.PurchaseOrder,
            PurchaseOrderType.PurchaseOrderUmbrella
        ];
    }

    getAllCertificateType(): CertificateType[] {
        return [
            CertificateType.Certificate,
            CertificateType.Procuration,
            CertificateType.Others
        ];
    }

    getAllGroups(): GroupDivision[] {
        return [
            GroupDivision.NacaoDigital,
        ];
    }

    getAllOriginGroups(): GroupOrigin[] {
        return [
            GroupOrigin.Marketing,
            GroupOrigin.Sales,
            GroupOrigin.Partner,
            GroupOrigin.Indication];
    }

    getAllReadjustmentQuoeficientGroups():GroupReadjustmentQuoeficient[]{
        return[
            GroupReadjustmentQuoeficient.IgpDiFgv,
            GroupReadjustmentQuoeficient.IgpMFgv,
            GroupReadjustmentQuoeficient.Ipc,
            GroupReadjustmentQuoeficient.Inpc,
            GroupReadjustmentQuoeficient.Ipca,
            GroupReadjustmentQuoeficient.Aditivo,
            GroupReadjustmentQuoeficient.NotApplicable
        ];
    }

    getAllStates() {
        return [
            'AC',
            'AL',
            'AP',
            'AM',
            'BA',
            'CE',
            'DF',
            'ES',
            'GO',
            'MA',
            'MT',
            'MS',
            'MG',
            'PA',
            'PB',
            'PR',
            'PE',
            'PI',
            'RJ',
            'RN',
            'RS',
            'RO',
            'RR',
            'SC',
            'SP',
            'SE',
            'TO'];
    }

    getAllSapItemType(): SapItemType[] {
        return [
            SapItemType.CnaeBilling,
            SapItemType.CnaeConsultant,
            SapItemType.ItemPurchaseOrder
        ]
    }

    listLastYears(lastYear = (new Date().getFullYear() + 3)) {
        let firstYear = 2020; //Ano do registro mais antigo no DB
        let years: number[] = new Array<number>();

        for (firstYear; firstYear <= lastYear; firstYear++)
            years.push(firstYear);

        return years.reverse();
    }

    listAllMonths() {
        return [{ number: 0, name: 'Janeiro' },
        { number: 1, name: 'Fevereiro' },
        { number: 2, name: 'Março' },
        { number: 3, name: 'Abril' },
        { number: 4, name: 'Maio' },
        { number: 5, name: 'Junho' },
        { number: 6, name: 'Julho' },
        { number: 7, name: 'Agosto' },
        { number: 8, name: 'Setembro' },
        { number: 9, name: 'Outubro' },
        { number: 10, name: 'Novembro' },
        { number: 11, name: 'Dezembro' }]
    }

    multiSelectMonths() {
        return [{ _id: '0', name: 'Janeiro' },
        { _id: '1', name: 'Fevereiro' },
        { _id: '2', name: 'Março' },
        { _id: '3', name: 'Abril' },
        { _id: '4', name: 'Maio' },
        { _id: '5', name: 'Junho' },
        { _id: '6', name: 'Julho' },
        { _id: '7', name: 'Agosto' },
        { _id: '8', name: 'Setembro' },
        { _id: '9', name: 'Outubro' },
        { _id: '10', name: 'Novembro' },
        { _id: '11', name: 'Dezembro' }]
    }

    formatMonth(value: number) {
        let months = [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro'
        ];

        return months[value] ? months[value] : "-";
    }

    getDropDownListItemsEnum(source: any, type: string) {
        var ddl = new Array<DropDownList>();
        for (let i of source) {
            let itemDdl = new DropDownList();
            itemDdl.id = i;
            if (type === "StatusApproval")
                itemDdl.itemName = this.transcriptStatusApproval(i);
            if (type === "StatusRefund")
                itemDdl.itemName = this.transcriptStatusRefund(i);
            if (type === "StatusInvoice")
                itemDdl.itemName = this.transcriptStatusInvoice(i);
            if (type === "GroupDivision")
                itemDdl.itemName = this.transcriptDivisionGroup(i);
            if (type === "Contract")
                itemDdl.itemName = this.transcriptContractType(i);
            if (type === "Role")
                itemDdl.itemName = this.transcriptInternalRole(i);
            if (type === "ProjectStatus")
                itemDdl.itemName = this.transcriptContractProjectFinancial(i);
            if (type === "StatusKenoby")
                itemDdl.itemName = this.transcriptStatusKenoby(i);
            if (type === "ProjectType")
                itemDdl.itemName = this.transcriptProjectType(i);
            if (type === "PurchaseOrderType")
                itemDdl.itemName = this.transcriptPurchaseOrderType(i);
            if (type === "CertificateType")
                itemDdl.itemName = this.transcriptCertificateType(i);
            if (type === "VendorInventory")
                itemDdl.itemName = this.transcriptVendorInventoryType(i);
            // if (type === "subDivision")
            //     itemDdl.itemName = this.transcriptSubDivision(i);
            ddl.push(itemDdl);
        }

        return ddl;
    }


    getDropDownListItems(source: any, descriptionId: string, descriptionName: string, params = []) {
        var ddl = new Array<DropDownList>();

        for (let i of source) {
            let itemDdl = new DropDownList();
            itemDdl.id = descriptionId != null ? i[descriptionId] : i;
            itemDdl.itemName = descriptionName != null ? i[descriptionName] : i;
            if (params.length > 0) {
                params.forEach(param => itemDdl[param] = i[param] ? i[param] : null);
            }
            ddl.push(itemDdl);
        }
        return ddl;
    }

    getDropDownListConsultant(source: any, descriptionId?: string, descriptionName?: string, descriptionKind?: string, descriptionDiv?: string, descriptionActive?: string, descriptionExcellenceCenter?: string) {
        var ddl = new Array<any>();

        for (let i of source) {
            let itemDdl = {}
            itemDdl['id'] = descriptionId != null ? i[descriptionId] : i;
            itemDdl['itemName'] = descriptionName != null ? i[descriptionName] : i;
            itemDdl['kind'] = descriptionKind != null ? this.transcriptContractType(i.contract.kind) : i;
            itemDdl['division'] = descriptionDiv != null ? this.transcriptDivisionGroup(i.division) : i;
            itemDdl['active'] = descriptionActive != null ? this.transcriptActive(i[descriptionActive]) : i;
            itemDdl['excellenceCenter'] = descriptionExcellenceCenter != null ? (i.excellenceCenter ? i.excellenceCenter._id : i) : i;
            ddl.push(itemDdl);
        }
        return ddl;
    }

    getDropDown(source: any) {
        const factory: DropDownFactory = new DropDownFactory();

        return source.map(item => {
            return {
                id: item._id ? item._id : null,
                itemName: item.name ? item.name : null
            };
        });
    }

    getDropDownSettings(
        singleSelection: boolean,
        text: string,
        enableCheckAll: boolean,
        selectAllText: string,
        unSelectAllText: string,
        enableSearchFilter: boolean,
        groupBy: string,
        classes: string,
        disabled?: boolean,
        badgeShowLimit?:Number
    ) {
        return {
            singleSelection: singleSelection,
            text: text,
            enableCheckAll: enableCheckAll,
            selectAllText: selectAllText,
            unSelectAllText: unSelectAllText,
            enableSearchFilter: enableSearchFilter,
            groupBy: groupBy,
            classes: classes,
            maxHeight: 300,
            disabled: disabled ? disabled : false,
            badgeShowLimit: badgeShowLimit ? badgeShowLimit : 5
        };
    }

    transcriptStatusInvoice(statusInvoice: StatusInvoice) {
        switch (statusInvoice) {
            case StatusInvoice.Received_Processing:
                return "Recebido / Processando";
            case StatusInvoice.Approved:
                return "Aprovada"
            case StatusInvoice.Denied:
                return "Reprovada"
            default:
                return '-';
        }
    };

    getStatusInvoice(): StatusInvoice[] {
        return [
            StatusInvoice.Received_Processing,
            StatusInvoice.Approved,
            StatusInvoice.Denied
        ];
    };

    getJustificationInvoice(): StatusJustification[] {
        return [
            StatusJustification.CNAE,
            StatusJustification.Divergent_value,
            StatusJustification.Others
        ]
    };

    transcriptJustification(statusJustify: StatusJustification) {
        switch (statusJustify) {
            case StatusJustification.CNAE:
                return "CNAE";
            case StatusJustification.Divergent_value:
                return "Valor divergente"
            case StatusJustification.Others:
                return "Outros"
            default:
                return '';
        };
    };

    countries() {
        return [
            "Afeganistão",
            "África do Sul",
            "Albânia",
            "Alemanha",
            "Andorra",
            "Angola",
            "Anguilla",
            "Antártida",
            "Antígua e Barbuda",
            "Arábia Saudita",
            "Argélia",
            "Argentina",
            "Armênia",
            "Aruba",
            "Austrália",
            "Áustria",
            "Azerbaijão",
            "Bahamas",
            "Bahrein",
            "Bangladesh",
            "Barbados",
            "Belarus",
            "Bélgica",
            "Belize",
            "Benin",
            "Bermudas",
            "Bolívia",
            "Bósnia-Herzegóvina",
            "Botsuana",
            "Brasil",
            "Brunei",
            "Bulgária",
            "Burkina Fasso",
            "Burundi",
            "Butão",
            "Cabo Verde",
            "Camarões",
            "Camboja",
            "Canadá",
            "Canárias",
            "Cazaquistão",
            "Ceuta e Melilla",
            "Chade",
            "Chile",
            "China",
            "Chipre",
            "Cingapura",
            "Colômbia",
            "Comores",
            "Congo",
            "Coréia do Norte",
            "Coréia do Sul",
            "Costa do Marfim",
            "Costa Rica",
            "Croácia",
            "Cuba",
            "Curaçao",
            "Diego Garcia",
            "Dinamarca",
            "Djibuti",
            "Dominica",
            "Egito",
            "El Salvador",
            "Emirados Árabes Unidos",
            "Equador",
            "Eritréia",
            "Eslováquia",
            "Eslovênia",
            "Espanha",
            "Estados Unidos",
            "Estônia",
            "Etiópia",
            "Fiji",
            "Filipinas",
            "Finlândia",
            "França",
            "Gabão",
            "Gâmbia",
            "Gana",
            "Geórgia",
            "Gibraltar",
            "Grã-Bretanha (Reino Unido, UK)",
            "Granada",
            "Grécia",
            "Groelândia",
            "Guadalupe",
            "Guam (Território dos Estados Unidos)",
            "Guatemala",
            "Guernsey",
            "Guiana",
            "Guiana Francesa",
            "Guiné",
            "Guiné Equatorial",
            "Guiné-Bissau",
            "Haiti",
            "Holanda",
            "Honduras",
            "Hong Kong",
            "Hungria",
            "Iêmen",
            "Ilha Bouvet",
            "Ilha de Ascensão",
            "Ilha de Clipperton",
            "Ilha de Man",
            "Ilha Natal",
            "Ilha Pitcairn",
            "Ilha Reunião",
            "Ilhas Aland",
            "Ilhas Cayman",
            "Ilhas Cocos",
            "Ilhas Cook",
            "Ilhas Faroes",
            "Ilhas Geórgia do Sul e Sandwich do Sul",
            "Ilhas Heard e McDonald (Território da Austrália)",
            "Ilhas Malvinas",
            "Ilhas Marianas do Norte",
            "Ilhas Marshall",
            "Ilhas Menores dos Estados Unidos",
            "Ilhas Norfolk",
            "Ilhas Salomão",
            "Ilhas Seychelles",
            "Ilhas Tokelau",
            "Ilhas Turks e Caicos",
            "Ilhas Virgens (Estados Unidos)",
            "Ilhas Virgens (Inglaterra)",
            "Índia",
            "Indonésia",
            "Irã",
            "Iraque",
            "Irlanda",
            "Islândia",
            "Israel",
            "Itália",
            "Jamaica",
            "Japão",
            "Jersey",
            "Jordânia",
            "Kiribati",
            "Kosovo",
            "Kuait",
            "Laos",
            "Lesoto",
            "Letônia",
            "Líbano",
            "Libéria",
            "Líbia",
            "Liechtenstein",
            "Lituânia",
            "Luxemburgo",
            "Macau",
            "Macedônia (República Yugoslava)",
            "Madagascar",
            "Malásia",
            "Malaui",
            "Maldivas",
            "Mali",
            "Malta",
            "Marrocos",
            "Martinica",
            "Maurício",
            "Mauritânia",
            "Mayotte",
            "México",
            "Micronésia",
            "Moçambique",
            "Moldova",
            "Mônaco",
            "Mongólia",
            "Montenegro",
            "Montserrat",
            "Myanma",
            "Namíbia",
            "Nauru",
            "Nepal",
            "Nicarágua",
            "Níger",
            "Nigéria",
            "Niue",
            "Noruega",
            "Nova Caledônia",
            "Nova Zelândia",
            "Omã",
            "Países Baixos Caribenhos",
            "Palau",
            "Palestina",
            "Panamá",
            "Papua-Nova Guiné",
            "Paquistão",
            "Paraguai",
            "Peru",
            "Polinésia Francesa",
            "Polônia",
            "Porto Rico",
            "Portugal",
            "Qatar",
            "Quênia",
            "Quirguistão",
            "República Centro-Africana",
            "República Democrática do Congo",
            "República Dominicana",
            "República Tcheca",
            "Romênia",
            "Ruanda",
            "Rússia (antiga URSS) - Federação Russa",
            "Saara Ocidental",
            "Saint-Pierre e Miquelon",
            "Samoa Americana",
            "Samoa Ocidental",
            "San Marino",
            "Santa Helena",
            "Santa Lúcia",
            "São Bartolomeu",
            "São Cristóvão e Névis",
            "São Martim",
            "São Martinho",
            "São Tomé e Príncipe",
            "São Vicente e Granadinas",
            "Senegal",
            "Serra Leoa",
            "Sérvia",
            "Síria",
            "Somália",
            "Sri Lanka",
            "Suazilândia",
            "Sudão",
            "Sudão do Sul",
            "Suécia",
            "Suíça",
            "Suriname",
            "Svalbard",
            "Tadjiquistão",
            "Tailândia",
            "Taiwan",
            "Tanzânia",
            "Território Britânico do Oceano índico",
            "Territórios do Sul da França",
            "Timor-Leste",
            "Togo",
            "Tonga",
            "Trinidad e Tobago",
            "Tristão da Cunha",
            "Tunísia",
            "Turcomenistão",
            "Turquia",
            "Tuvalu",
            "Ucrânia",
            "Uganda",
            "Uruguai",
            "Uzbequistão",
            "Vanuatu",
            "Vaticano",
            "Venezuela",
            "Vietnã",
            "Wallis e Futuna",
            "Zâmbia",
            "Zimbábue",
        ];
    }

    listAllDimensions(){
        return [{number:1, name: 'Setor'},
            {number:2, name: 'Centro de Excelência'},
            {number:3, name: 'Área de Suporte'}
        ]
    }

    transcriptAccountingType(type: AccountingType) {
        switch(type) {
            case AccountingType.BillingLetter:
                return 'CARTA DE FATURAMENTO';
            case AccountingType.Approval:
                return 'APROVAÇÃO DE CONSULTOR'
            case AccountingType.Refund:
                return 'REEMBOLSO'
            case AccountingType.PurchaseOrder:
                return 'PEDIDOS DE COMPRA'
            default:
                return ''
        }
    }

    getAccountingTypes() {
        return [
            {
                type: AccountingType.BillingLetter,
                name: 'CARTA DE FATURAMENTO'
            },
            {
                type: AccountingType.Approval,
                name: 'APROVAÇÃO DE CONSULTOR'
            },
            {
                type: AccountingType.Refund,
                name: 'REEMBOLSO'
            },
            {
                type: AccountingType.PurchaseOrder,
                name: 'PEDIDOS DE COMPRA'
            },
        ]
    }

    transcriptVendorInventoryType(id: string){
        const map = {
            [VendorInventoryType.PJ]: "PJ",
            [VendorInventoryType.Vendor]: "Fornecedor"
        };

        if (!map[id])
            return '-';

        return map[id];
    }

    getAllVendorInventoryTypes(){
        return [
            VendorInventoryType.PJ,
            VendorInventoryType.Vendor
        ];
    }

    getClicksignDocumentsTypes() {
        return [
            'contract',
            'confidentialityTerm',
            'renovation',
            'readjustment',
            'changeCompany',
            'discharge',
            'distract'
        ]
    }

    transcriptSelfFillRequestStatus(status: SelfFillRequestStatus) {
        switch(status) {
            case SelfFillRequestStatus.Pending:
                return 'Em Análise'

            case SelfFillRequestStatus.Approved:
                return 'Aprovado'

            case SelfFillRequestStatus.Reproved:
                return 'Reprovado'
        }
    }

    excellenceCenterIds() {
        return {
            SGA: "61b795f946958f4302022988"
        }
    }

    getLaptopTransportType() {
        return [
            {
                code: 1,
                description: 'Equipamento será enviado pelo Consultor(a)'
            },
            {
                code: 2,
                description: 'Equipamento será retirado via Loggi'
            }
        ]
    }

    transcriptLapTopTransportType(transportCode: LaptopTransportType) {
        switch (transportCode) {
            case LaptopTransportType.Consultant:
                return 'Equipamento será enviado pelo Consultor(a)'
            case LaptopTransportType.Loggi:
                return 'Equipamento será retirado via Loggi'
            default:
                return ''
        }
    }

    getDayPeriod() {
        return [
            'Manhã',
            'Tarde',
            'Horário comercial'
        ]
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/CommonHelper.ts